import { render } from "./AddBusiness.vue?vue&type=template&id=d74638b6&scoped=true"
import script from "./AddBusiness.vue?vue&type=script&lang=js"
export * from "./AddBusiness.vue?vue&type=script&lang=js"

import "./AddBusiness.vue?vue&type=style&index=0&id=d74638b6&scoped=true&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d74638b6"]])

export default __exports__